import React, { useState, useEffect, ChangeEvent } from "react";
import { UpdateDataTSXProps, departmentPops, employeeDataProps } from "../../../../utils/types";
import * as APIURL from "../../../../config/config";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { AxiosError } from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const UpdateUser : React.FC<UpdateDataTSXProps> = ({id}) => {
    
    const [departments, setDepartments] = useState<React.JSX.Element[]>([]);
    const [userDetails, setUserDetails] = useState<employeeDataProps>({
        id : 0,
        profile_picture : '',
        first_name : '',
        last_name : '',
        email : '',
        position : '',
        department : 0,
        status : '',
        date_created : ''
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [accountUpdated, setAccountUpdate] = useState<boolean>(false);
    const [updateStatus, setUpdateStatus] = useState('');

    useEffect(()=>{
        async function getUserDetails() {
            try{
                const userData = await api.get(APIURL.GET_USER_DETAILS_END_POINT+id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setUserDetails(userData.data[0]);
            }catch(e){
                
            }
        }
        getUserDetails();
    }, [id]);

    useEffect(()=>{
        async function getDepartments () {
            const getDepartmentResult : React.JSX.Element[] = []; 
            try{
                const departments = await api.get(APIURL.GET_DEPARTMENT_END_POINT, {headers : {'Authorization' : 'Bearer '+getToken()}});
                 departments.data.forEach((data : departmentPops)=>{
                    getDepartmentResult.push(
                        <option value={data.id} selected={userDetails.department === data.id} className='text-gray-600'>{data.department_name}</option>
                    )
                 })
                 setDepartments(getDepartmentResult);
                 setLoading(false);
            }catch(e){
                const error = (e as AxiosError);

                switch (error.response?.status) {
                    case 401:
                        setDepartments([
                            <option className='text-red-500'>Unauthorized access.</option>
                        ])
                        break;
                    case 404:
                        setDepartments([
                            <option className='text-red-500'>No Department found.</option>
                        ])
                        break;
                    case 500:
                        setDepartments([
                            <option className='text-red-500'>Something went wrong!</option>
                        ])
                        break;
                    default:
                        setDepartments([
                            <option className='text-red-500'>An error occured!</option>
                        ])
                        break;

                }

                setLoading(false);
            }
        }
       getDepartments ();
    }, [userDetails.department])

    function updateTextBoxValue(e : ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
        const {name, value} = e.target;

        setUserDetails({
            ...userDetails,
            [name] : value
        });
    }

    function updateUser(){
        setIsLoading(true);

        setTimeout(async()=>{
            try{
                await api.post(APIURL.UPDATE_USER_ACCOUNT_END_POINT, userDetails, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setAccountUpdate(true);
                setUpdateStatus('User account updated!')
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    setUpdateStatus('Unauthorized access!');
                }else{
                    setUpdateStatus('An error occured!');
                }
            }
            setIsLoading(false);
        },500)
    }

    return (
        <div className="min-w-[28rem] max-w-[28rem] relative">
            <div className={loading ? 'modal-loader' : 'hidden'}>
                <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
            </div>
            <div className="text-center uppercase font-medium text-gray-600 text-md">
                Update {userDetails.first_name} {userDetails.last_name}'s Account
            </div>
            <form>
                <div className={accountUpdated ? 'text-green-600' : 'text-red-500'}>
                    {updateStatus}
                </div>
                <div className='input-container'>
                    <input type="text" className='text-box' value={userDetails.first_name} onChange={updateTextBoxValue} name="first_name" placeholder="First name" />
                </div>
                <div className='input-container'>
                    <input type="text" className='text-box' value={userDetails.last_name} onChange={updateTextBoxValue} name="last_name" placeholder="Last name" />
                </div>
                <div className='input-container'>
                    <input type="Email" className='text-box' value={userDetails.email} onChange={updateTextBoxValue} name="email" placeholder="Email" />
                </div>
                <div className='input-container'>
                    <input type="text" className='text-box' value={userDetails.position} onChange={updateTextBoxValue} name="position" placeholder="Position" />
                </div>
                <div className='input-container'>
                    <select className='text-box' name="department" onChange={updateTextBoxValue} >
                        <option value="" className='text-gray-400'>Select Department</option>
                        {departments}
                    </select>
                </div>
                <div className='input-container'>
                    {isLoading ? (
                        <button type="button" disabled className='button button-disabled'>
                            <FontAwesomeIcon className='animate-spin' icon={faSpinner} />  Processing....
                        </button>
                    ) : (
                        <button type="button" onClick={updateUser} className='button button-vcc-primary'>
                            Update Account
                        </button>
                    )}
                </div>
            </form>
        </div>
    );
}

export default UpdateUser;